import { render, staticRenderFns } from "./RacksOld.vue?vue&type=template&id=0ca0f362&scoped=true&"
import script from "./RacksOld.vue?vue&type=script&lang=js&"
export * from "./RacksOld.vue?vue&type=script&lang=js&"
import style0 from "./RacksOld.vue?vue&type=style&index=0&id=0ca0f362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0f362",
  null
  
)

export default component.exports